import React from 'react'
import { useSelector } from 'react-redux'
import { Route, Redirect } from 'react-router-dom'
import paths from './paths'

const PrivateRoute = props => {
    const restaurantInfo = useSelector(state => state.RestaurantReducer) || {}
    const user = useSelector(state => state.AccountReducer.user)
    const { timerSuccess } = useSelector(state => state.AppReducer)
    // TODO: timmer
    // if (restaurantInfo && !timerSuccess) {
    //     return null
    // }
    const { component: Component, path, exact } = props
    return (
        <Route
            path={path}
            exact={exact}
            render={props =>
                restaurantInfo && user ? (
                    <Component {...props} />
                ) : (
                    <Redirect to={paths.home} />
                )
            }
        />
    )
}

export default PrivateRoute
